import { AppBar, Box, Container, Typography, useMediaQuery } from "@mui/material";
import { blue, Logo, yellow } from "./styles";
import { ReactComponent as CallIcon } from '../Components/CallIcon.svg';
import { Motion } from "../Components/Motion";
import { useLocation, useNavigate } from "react-router-dom";
import { logAnalytics, phoneClick } from "../firebase_init";

export function Bar({
    boxSetHeight,
    barHeight = 50,
    colors = {
        top: 'transparent',
        main: blue,
    },
    threshold = 0,
    children
}) {
    const location = useLocation();
    const navigate = useNavigate();
    const tablet = useMediaQuery(`(max-width:1050px)`);
    const boxHeight = 70;

    const scrollToEl = (elId) => {
        const el = document.getElementById(elId);
        if (el) {
            el.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    }

    const moveToEl = (elId) => {
        const isPage = location.pathname === '/';
        if (!isPage) {
            navigate('/').then((result) => {
                setTimeout(() => {
                    scrollToEl(elId);
                }, 200);
            }).catch((err) => { });
        }
        scrollToEl(elId);
    }

    return <>
        <Box sx={{ flexGrow: 1, mb: '16px' }}>
            <AppBar position="fixed" elevation={0} sx={{
                bgcolor: colors.main,
                height: `${boxHeight}px`,
                zIndex: (theme) => theme.zIndex.drawer + 1
            }}>
                <Container maxWidth='xl' sx={{ position: 'relative', width: '100%', height: '100%' }}>

                    <Box sx={{
                        width: '100%', height: '100%', px: { xs: '16px', sm: '16px', md: '30px' },
                        display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center',
                    }}>
                        <Logo sx={{ mr: '10px' }} />
                        <Box sx={{ display: 'flex', flexDirection: 'row', ml: 'auto', gap: '50px', alignContent: 'center', alignItems: 'center' }}>
                            {!tablet && <>
                                <Typography sx={{ color: 'white', fontFamily: 'alexandria', fontWeight: 700, cursor: 'pointer' }} onClick={() => moveToEl("cozajistime")}>Co nabízíme?</Typography>
                                <Typography sx={{ color: 'white', fontFamily: 'alexandria', fontWeight: 700, cursor: 'pointer' }} onClick={() => moveToEl("cenik")}>Ceník</Typography>

                                <Motion scale={1.02}>
                                    <Box component={'a'} href="tel:+420797996873" onClick={() => {
                                        logAnalytics("phone_click_fire");
                                        phoneClick();
                                    }}
                                        sx={{ textDecoration: 'none', height: '50px', borderRadius: '999px', bgcolor: yellow, display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'center' }}>
                                        <Typography sx={{ color: blue, px: '20px', fontFamily: 'alexandria', fontWeight: 700, }}>797996873</Typography>
                                    </Box>
                                </Motion>
                            </>}
                            {tablet && <Motion scale={1.02}>
                                <Box component={'a'} href="tel:+420797996873" onClick={() => {
                                    logAnalytics("phone_click_fire");
                                    phoneClick();
                                }}>
                                    <CallIcon style={{ display: 'block' }} />
                                </Box>
                            </Motion>}
                        </Box>
                    </Box>


                </Container>
            </AppBar>
            <Box sx={{ height: `${boxHeight}px`, mb: '16px' }} />
        </Box>
    </>;
}